import { Color } from '@diritto/common/style/color';

interface AuthorBadgeNewIconProps {
  color?: Color;
}

export const AuthorBadgeIcon = ({ color = Color.Blue600 }: AuthorBadgeNewIconProps) => (
  <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 9C0 4.02944 4.02944 0 9 0H21C25.9706 0 30 4.02944 30 9C30 13.9706 25.9706 18 21 18H9C4.02944 18 0 13.9706 0 9Z"
      fill={color}
    />
    <path
      d="M9.73633 6.65234V6.4082H11.6211V5.65625H6.88477V6.4082H8.80859V6.64258C8.80371 7.84863 7.97852 8.98145 6.61133 9.44531L7.10938 10.168C8.13477 9.80664 8.89648 9.05957 9.27734 8.11719C9.6582 8.97656 10.3857 9.66016 11.377 10.002L11.8457 9.2793C10.5078 8.83008 9.73145 7.77051 9.73633 6.65234ZM7.77344 11.5352H12.627V13.8301H13.5547V10.7832H7.77344V11.5352ZM12.627 10.3535H13.5547V8.10742H14.8242V7.32617H13.5547V5.08008H12.627V10.3535ZM22.1387 5.08008H21.2109V13.8203H22.1387V9.33789H23.4961V8.56641H22.1387V5.08008ZM15.332 11.4863L15.8496 12.209C18.7305 10.7881 19.8438 8.52734 19.8535 5.99805H15.7715V6.76953H18.9062C18.7158 8.81055 17.5244 10.3926 15.332 11.4863Z"
      fill="white"
    />
  </svg>
);
